import { Route } from 'react-router-dom';
export default Route;


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_umi@2.6.8@umi/lib/Route.js
// module id = null
// module chunks = 